import { useAuth } from '@clerk/clerk-react';
import type { AuthContext } from '@mesa/core/zero';
import { useQuery } from '@tanstack/react-query';

import { installationsQuery, type Installation } from './org';
import { useUser } from './user';

// Hook to create the auth context for Zero
export function useAuthContext(): AuthContext | undefined {
  const { userId } = useAuth();
  const { user } = useUser();
  const { data: installations } = useQuery(installationsQuery());

  if (!userId || !user || !installations) {
    return undefined;
  }

  return {
    userId: user.id.toString(),
    githubId: user.id,
    installations: installations
      .filter(
        (installation): installation is Installation & { account: { login: string; type: 'User' | 'Organization' } } =>
          installation.account.type === 'User' || installation.account.type === 'Organization'
      )
      .map((installation) => ({
        id: installation.id,
        account: {
          login: installation.account.login,
          type: installation.account.type,
        },
      })),
  };
}
